import Image from 'next/image';

import { StartTrialInput } from '../StartTrialInput';

const styles = {
  container: {
    background:
      'linear-gradient(180deg, rgba(242, 250, 255, 0) 0%, #F2FAFF 64.35%, #F2FAFF 100%)',
  },
};

function NoCredit() {
  return (
    <div className="mt-2 pt-1 text-center text-[12px] font-normal text-[#616366] md:text-left md:text-base">
      No Credit Card Required. Cancel Anytime 🙌
    </div>
  );
}

function Heading() {
  return (
    <div className="m-auto px-4 pb-1 text-center text-[28px] font-medium text-[#3D3E40]  md:px-0 md:text-[36px]">
      Get Started with
      <br />
      AbleSpace for FREE!
    </div>
  );
}

function TextArea() {
  return (
    <div className="mt-6 flex flex-col items-center justify-center">
      <Heading />
      <div className="mt-4 flex flex-col items-center space-y-4">
        <StartTrialInput />
        <NoCredit />
      </div>
      <Image
        className="mt-8 w-[80%]"
        src="/images/footer-top-new.png"
        alt="Embark on your journey with a complimentary 1-month trial"
        width={600}
        height={600}
      />
    </div>
  );
}

export const Footertopnew = () => {
  return (
    <div
      style={styles.container}
      className="overflow-hidden bg-origin-padding py-10 md:px-16 lg:px-32 lg:pb-16 lg:pt-4"
    >
      <div className="container mx-auto text-center md:text-left">
        <TextArea />
      </div>
    </div>
  );
};
